import ThemeConfig from '~/tailwind.config'

const useTheme = () => ThemeConfig.theme.extend

export default useTheme
